(() => {
  const dialog = document.getElementById('kt-legal-guarantee-dialog');
  if (!dialog || typeof dialog.showModal !== 'function') return;
  let opener;
  function prepareLinks() {
    document.querySelectorAll('[data-kt-legal-guarantee]').forEach(link => {
      link.setAttribute('aria-haspopup', 'dialog');
      link.setAttribute('aria-controls', dialog.id);
    });
  }
  prepareLinks();
  document.addEventListener('shopify:section:load', prepareLinks);
  document.addEventListener('click', event => {
    const link = event.target.closest('[data-kt-legal-guarantee]');
    if (!link || event.defaultPrevented || event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    opener = link;
    dialog.showModal();
    document.body.classList.add('kt-legal-guarantee-open');
  });
  dialog.addEventListener('click', event => {
    if (event.target !== dialog) return;
    const bounds = dialog.getBoundingClientRect();
    if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
  });
  dialog.addEventListener('keydown', event => {
    if (event.key !== 'Tab') return;
    const controls = dialog.querySelectorAll('button:not([disabled]), a[href]');
    const first = controls[0];
    const last = controls[controls.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });
  dialog.addEventListener('close', () => {
    document.body.classList.remove('kt-legal-guarantee-open');
    if (opener?.isConnected) opener.focus({preventScroll:true});
  });
})();
